import moment from 'moment';

export function getCurrentDate() {
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth()+1; //January is 0!
  let yyyy = today.getFullYear();

  if(dd < 10) {
    dd = '0' + dd;
  } 
 
  if(mm < 10) {
    mm = '0' + mm;
  }

  today = mm + '/' + dd + '/' + yyyy;

  return today;
}

export function formatDate(dateString, format) {
  let date = moment(dateString);

  return date.format(format);
}

export function getFirstDayInMonth() {
  let newDate = moment();

  return newDate.format('YYYY-MM') + '-01';
}

export function getLastDayInMonth() {
  let newDate = moment();

  return newDate.format('YYYY-MM') + '-' + moment().daysInMonth();
}

export { getFirstDayInMonth as firstDayInMonth };
export { getLastDayInMonth as lastDayInMonth };
export { getCurrentDate as currentDate };


// WEBPACK FOOTER //
// ./client/app/shared/utils/date.utils.js